<template>
    <div>
        <loading
            :active.sync="loadingContent"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Info Penting</div>
        </div>
        <div id="appCapsule">
            <div class="section inset mt-2">
                <div
                    class="alert alert-outline-warning mb-2"
                    role="alert"
                    style="background-color: #fffae6; border-color: #ffedbe"
                >
                    <div style="display: flex; line-height: 15px">
                        <ion-icon
                            name="warning-outline"
                            style="font-size: 23px; margin-right: 10px"
                        ></ion-icon>
                        <span style="color: #333; font-size: 12px"
                            >Akun tidak akan bisa dikembalikan setelah
                            dihapus.</span
                        >
                    </div>
                </div>
            </div>
            <div class="section inset mt-2">
                <div class="wide-block pt-2 pb-2">
                    <dt>{{ customer.name }}</dt>
                    <dd class="mb-0">
                        {{ customer.phone }}
                        <span v-if="customer.email != null"
                            >({{ customer.email }})</span
                        >
                    </dd>
                </div>
            </div>
            <div class="section inset mt-2">
                <h4>Hal yang terjadi setelah hapus akun:</h4>
                <ol style="font-size: 13px">
                    <li>
                        Nomor Handphone, e-mail dan No KTP (Jika ada) tidak bisa
                        di pakai kembali.
                    </li>
                    <li>
                        Beberapa data terkait transaksi akan di simpan oleh
                        {{ VUE_ENV.VUE_APP_NAME }} berdasarkan ketentuan
                        peraturan perundang-undangan.
                    </li>
                    <li>
                        Saldo dan Komisi yang mengendap di
                        {{ VUE_ENV.VUE_APP_NAME }} tidak dapat lagi digunakan
                        (Hangus).
                    </li>
                    <li>
                        Semua Downline yang dimiliki akan keluar dari saluran
                        referral dan tidak dapat dikembalikan lagi.
                    </li>
                    <li>
                        Setelah pengajuan penghapusan akun disetujui, kamu tidak
                        dapat lagi mengakses akun kamu.
                    </li>
                </ol>
            </div>
            <div class="form-button-group transparent">
                <router-link
                    :to="{ name: 'account.delete.form' }"
                    class="btn btn-primary btn-block btn-lg"
                    style="height: 45px"
                    >Lanjut</router-link
                >
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    export default {
        data() {
            return {
                loadingContent: true,
            };
        },
        created() {
            setTimeout(() => (this.loadingContent = false), 500);
        },
        computed: {
            ...mapState(['VUE_ENV', 'customer']),
        },
    };
</script>
